<template>
 <templateList :type="0"/>
</template>

<script>
import templateList from './components/templateList.vue'
let timer = null
export default {
    name: 'myChoice',
    components: {
        templateList,
    },
}
</script>
